module.exports = "/_next/static/images/projectTechnologyDeployment1-d22b4059c92160853c9a37fae96d65a0.webp";